import React from "react";
import { Switch, Route } from "react-router-dom";
import { Speed, HelpOutline, Settings } from "@material-ui/icons";

import * as ROUTES from "../../constants/routes";
import { withAuthorization } from "../Session";
import { DashboardLayout } from "../UI";
import DashboardHome from "../DashboardHome";
import DashboardSettings from "../DashboardSettings";
import DashboardHelp from "../DashboardHelp";

const NAV_ITEMS = [
  { label: "My Dashboard", icon: <Speed />, route: ROUTES.DASHBOARDHOME },
  { label: "Settings", icon: <Settings />, route: ROUTES.DASHBOARDSETTINGS },
  { label: "Help", icon: <HelpOutline />, route: ROUTES.DASHBOARDHELP },
];

const UserDashboard = () => (
  <DashboardLayout navItems={NAV_ITEMS}>
    <Switch>
      <Route path={ROUTES.DASHBOARDHOME} component={DashboardHome} />
      <Route path={ROUTES.DASHBOARDSETTINGS} component={DashboardSettings} />
      <Route path={ROUTES.DASHBOARDHELP} component={DashboardHelp} />
      <Route exact path={ROUTES.USERDASHBOARD} component={DashboardHome} />
    </Switch>
  </DashboardLayout>
);

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(UserDashboard);
